import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
//import colors from "../../colors";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }

  render() {
    return (
      <div
      className="cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: "#f0f5ff",
        }}
      >
         
          <Slider />
          <HomeCardDeck />
          <div style={{ padding: "10px" }}>
            <MDBCard style={{ width: "100%", textAlign: "justify" }}>
              <MDBCardBody>
                <MDBCardTitle style={{ color: "blue" }}>
                  Decision Support System Development for Irrigation Water
                  Allocation{" "}
                </MDBCardTitle>
                {/* <MDBCardText> */}
                Irrigation scheduling is the decision of when and how much water
                to apply to a field. Its purpose is to maximize irrigation
                efficiencies by applying the exact amount of water needed to
                replenish the soil moisture to the desired level. Irrigation
                scheduling saves water and energy. All irrigation scheduling
                procedures consist of monitoring indicators that determine the
                need for irrigation. The importance of Irrigation scheduling is
                that it enables the irrigator to apply the exact amount of water
                to achieve the goal. This increases irrigation efficiency. A
                critical element is accurate measurement of the volume of water
                applied or the depth of application.
                <br />
                In this study we are estimating the irrigation requirement for
                the upcoming days based on the based on the actual standing crop
                area in field estimated from remote sensing information. The
                irrigation requirement is estimated based on near real-time and
                forecasted soil moisture conditions simulated by hydrological
                model with real-time and forecasted meteorological inputs
                {/* </MDBCardText> */}
              </MDBCardBody>
            </MDBCard>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
